import * as React from 'react';

type PossibleRef<T> = React.Ref<T> | undefined;

function setRef<T>(ref: PossibleRef<T>, value: T) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref !== null && ref !== undefined) {
    (ref as React.RefObject<T>).current = value;
  }
}

function composeRefs<T>(...refs: PossibleRef<T>[]) {
  return (node: T) => refs.forEach((ref) => setRef(ref, node));
}

function useComposedRefs<T>(...refs: PossibleRef<T>[]) {
  // The dependency list is the variadic `refs` array. The React Compiler lint
  // requires a statically analyzable array literal, which isn't possible for a
  // variable number of refs, so both hook rules are disabled here.
  // eslint-disable-next-line react-hooks/use-memo, react-hooks/exhaustive-deps -- deps are the variadic refs array; no static literal can list a variable number of refs
  return React.useCallback(composeRefs(...refs), refs);
}

export { useComposedRefs };
